import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Group } from 'src/app/models/group';

@Component({
  selector: 'app-group-detail',
  templateUrl: './group-detail.component.html',
  styleUrls: ['./group-detail.component.css']
})
export class GroupDetailComponent implements OnInit {
  group: Group = new Group(null);
  groupId: string;
  editMode: boolean = false;

  constructor(
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.group = this.route.snapshot.data.currentGroup;
    this.setEditMode(this.group.rules == null);
  }

  setEditMode(isOn: boolean) {
    this.editMode = isOn;
  }

}
